<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import * as utils from "src/store/utils";
import printHead from "./../layout/print-head.vue";
import {
  setInfo1,
  setInfo2,
  setInfo3,
  setInfo4,
  setInfo5,
  setInfo6,
  setInfo7,
  setInfo8,
  setArray
} from "./config";
const textAlign = "right";
const labelWidth = 90;

@Component({
  name: "normal-print",
  components: {
    printHead
  }
})
export default class App extends Vue {
  list = [];
  tableHead1 = {
    style: {
      flexDirection: "column"
    },
    children: []
  };
  tableHead2 = {
    style: {
      flexDirection: "row"
    },
    children: []
  };

  tableHead3 = {
    style: {
      flexDirection: "row"
    },
    children: []
  };
  tableHead4 = {
    style: {
      flexDirection: "row"
    },
    children: []
  };

  tableHead5 = {
    style: {
      flexDirection: "row"
    },
    children: []
  };

  tableHead6 = {
    style: {
      flexDirection: "column"
    },
    children: []
  };
  detailInfo = {}
  ACCESSORY_QUOTED_ITEM_NORMAL_PRINT() {
    let ids = this.$route.query.ids
    ids = ids.split(',')
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .ACCESSORY_QUOTED_ITEM_NORMAL_PRINT({
          ids,
          "pageNumber": 1,
          "pageSize": 999
        })
        .done(res => {
          resolve(res);
        })
        .fail(err => {
          reject();
        });
    });
  }
  mounted() {
    this.ACCESSORY_QUOTED_ITEM_NORMAL_PRINT().then(res => {
      let result = splitArray(res.data.records)
      this.list = result.map(item => {
        return {
          tableHead1: setInfoTableHead1.call(this, item),
          tableHead2: setInfoTableHead2.call(this, item),
          tableHead4: setInfoTableHead4.call(this, item),
          tableHead5: setInfoTableHead5.call(this, item),
          tableHead6: setInfoTableHead6.call(this, item)
        };
      });
      // 分rawList
      function splitArray(resList) {
        return resList.reduce((pre, cur) => {
          pre.push(cur)
          let starNum, endNum
          cur.rawList.length > 12 && cur.rawList.forEach((_, index, arr) => {
            let curItem = utils.JsonDeepCopy(cur);
            starNum = index === 12 ? 0 : starNum
            endNum = index === arr.length - 1 ? arr.length : index
            curItem['rawList'] = arr.slice(starNum, endNum)
            if (index !== 0 && index % 12 === 0) {
              if (index === 12) {
                pre[pre.length - 1] = curItem
                starNum = index
                return
              }
              pre.push(curItem)
              starNum = index
            }
            if (arr.length - 1 === index && index > 12 && index % 12 !== 0) {
              pre.push(curItem)
            }
          })
          return pre
        }, [])
      }
      function setInfoTableHead6() {
        return {
          style: {
            flexDirection: "column"
          },
          children: [setInfo8.call(this)]
        };
      }
      function setInfoTableHead5(item) {
        return {
          style: {
            flexDirection: "row"
          },
          children: [
            setInfo7.call(this, item)
            // {
            //   width: null,
            //   text: "备注"
            // }
          ]
        };
      }
      function setInfoTableHead4(item) {
        return {
          style: {
            flexDirection: "row"
          },
          children: [setInfo5.call(this, item), setInfo6.call(this, item)]
        };
      }
      function setInfoTableHead2(item) {
        const innerSlot = {
          children: [
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            },
            {
              width: null,
              text: ""
            }
          ]
        };
        const info3 = setInfo3(item);
        info3.children = info3.children.concat(
          item.rawList.map(formatList)
        );
        // info3.children = setArray(info3.children, 10, innerSlot);
        let length = item.rawList.length > 8 ? 14 : 10
        info3.children = setArray(info3.children, length, innerSlot);
        return {
          style: {
            flexDirection: "row"
          },
          children: [info3, setInfo4(item)]
        };
        function formatList(inner, $index) {
          return {
            children: [
              {
                text: $index + 1
              },
              {
                width: null,
                text: inner.rawDesc
              },
              {
                width: null,
                text: inner.rawType
              },
              {
                width: null,
                text: inner.baseUnit
              },
              {
                width: null,
                text: inner.qty
              },
              {
                width: null,
                text: inner.price
              },
              {
                width: null,
                text: inner.lossPct
              },
              {
                width: null,
                text: inner.rawAmount
              }
            ]
          };
        }
      }
      function setInfoTableHead1(item) {
        return {
          children: [setInfo1(item)]
        };
      }
    });
  }
  render(h) {
    return (
      <div class="excipient-print">
        {this.list.map(item => {
          return (
            <div class="excipient-print__item">
              <print-head title={item.companyName}></print-head>
              <multiline-print
                {...{
                  props: {
                    info: item.tableHead1
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.tableHead2
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.tableHead4
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.tableHead5
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.tableHead6
                  }
                }}
              ></multiline-print>
            </div>
          );
        })}
      </div>
    );
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .excipient-print__item {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
  }
}
.excipient-print__item {
  margin-bottom: 2mm;
  page-break-inside: avoid !important;
    page-break-before: unset !important;
}
</style>